var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"review"},[_c('div',{staticClass:"instructions"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.consumer_Rights.name))]),_vm._v(" "),_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"instructionses",domProps:{"innerHTML":_vm._s(_vm.consumer_Rights.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }